import { get, isEmpty } from 'lodash'

const transformToUpdateLocationTypeImageDetailsArgs = data => ({
  image: isEmpty(data.image)
    ? null
    : get(data, 'image[0].originFileObj', undefined),
  icon: isEmpty(data.icon)
    ? null
    : get(data, 'icon[0].originFileObj', undefined),
})

export default transformToUpdateLocationTypeImageDetailsArgs
